import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { RestResponse } from 'app/modules/common/entities/rest.response.generic.model';
import { ApiService } from '../../common/services/api.service';
import API from '../../common/services/api.config.json';
import { PlantillaTemplate } from 'app/modules/common/entities/plantilla-template.model';
import { DownloadableDocument } from 'app/modules/common/entities/dropdown/downloadable-document.model';

@Injectable({
    providedIn: 'root'
})
export class CommonTemplateService {

    constructor(
        private apiService: ApiService,
    ) { }


    /**
     * Get all Plantilla Citation templates
     * @returns All Plantilla Citation templates
     */
    getTemplates(control: string): Observable<RestResponse<PlantillaTemplate[]>> {
        // build URL
        const url = (API.PlantillaTemplate.templates as string).replace("{control}", control);
        // call API
        return this.apiService.get(url);
    }


    /**
     * Create template in the server
     * @param control Server side Controller name
     * @param model Plantilla Template model
     * @returns Observable API call
     */
    saveNewTemplate(control: string, model: any): Observable<RestResponse<null>> {

        // build URL
        const url = (API.PlantillaTemplate.saveTemplate as string).replace("{control}", control);
        // send post request
        return this.apiService.post(url, model);

    }

    /**
     * Delete given template
     * @param id Template ID
     * @param control Controller name
     * @returns Subscribable API call
     */
    deleteTemplate(id: number, control: string): Observable<RestResponse<null>> {
        // build URL
        const url = (API.PlantillaTemplate.deleteTemplate as string)
            .replace("{control}", control)
            .replace('{templateId}', id.toString());
        // call api
        return this.apiService.delete(url);
    }


    /**
     * Download given template
     * @param id Template ID
     * @param controller Plantilla Template controller name
     * @returns File Download subscriber
     */
    downloadTemplate(id: number, control: string): Observable<RestResponse<DownloadableDocument>> {
        // build URL
        const url = (API.PlantillaTemplate.downloadtemplate as string)
            .replace("{control}", control)
            .replace('{templateId}', id.toString());
        // call api
        return this.apiService.get(url);
    }

}